import { RootState } from 'handlers';

export const getCreditScoreHistoryState = ({ creditScoreHistory }: RootState) => creditScoreHistory.history ?? null;
